import { render, staticRenderFns } from "./ToDuBaBuoni.vue?vue&type=template&id=7d7dc680&scoped=true"
import script from "./ToDuBaBuoni.vue?vue&type=script&lang=js"
export * from "./ToDuBaBuoni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7dc680",
  null
  
)

export default component.exports